export default __webpack_public_path__ + "static/media/TowerC.3a6b2b21.jpg";